import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { debounceTime, map, shareReplay, switchMap, tap } from "rxjs/operators";
import { Curso } from "../_models/curso";
import { BehaviorSubject, combineLatest, of } from "rxjs";

const API_URL = environment.apiUrl;

@Injectable({ providedIn: "root" })
export class CursosService {
  cursos$ = this.http
    .get<Array<Curso>>(`${API_URL}/api/cursos/true`)
    .pipe(shareReplay(1));

  cursosAdmisiones$ = this.http
    .get<Array<Curso>>(`${API_URL}/api/cursos/true`, { params: { seccionExclude: -1} })
    .pipe(shareReplay(1));

  cursosNotParent$ = this.http
    .get<Array<Curso>>(`${API_URL}/api/cursos/false`)
    .pipe(shareReplay(1));

  private seccionBS = new BehaviorSubject<number>(-1);
  seccion$ = this.seccionBS.asObservable();

  private seccionExcludeBS = new BehaviorSubject<number>(-1);
  seccionExclude$ = this.seccionExcludeBS.asObservable();

  private params$ = combineLatest([this.seccionBS, this.seccionExcludeBS]).pipe(
    map(([seccion, seccionExclude]) => {
      const params: any = {};
      if (seccion > -1) {
        params.seccion = seccion;
      }
      if (seccionExclude > 0) {
        params.seccionExclude = seccionExclude;
      }
      return params;
    })
  );

  private cursosSeccion$ = this.params$.pipe(
    debounceTime(500),
    switchMap((_params) =>
      this.http.get<Curso[]>(`${API_URL}/api/cursos/buscar`, {
        params: _params,
      })
    ),
    shareReplay(1)
  );

  cursosBySeccion$ = this.cursosSeccion$.pipe(map((res: any) => res));

  cursosBySeccionEnum$ = of([
    { id: 1, nombre: "Primero", nickname: '1', orden: 300, seccion: 2 },
    { id: 2, nombre: "Segundo", nickname: '2', orden: 400, seccion: 2 },
    { id: 3, nombre: "Tercero", nickname: '3', orden: 500, seccion: 2 },
    { id: 4, nombre: "Cuarto", nickname: '4', orden: 600, seccion: 2 },
    { id: 5, nombre: "Quinto", nickname: '5', orden: 700, seccion: 3 },
    { id: 6, nombre: "Sexto", nickname: '6', orden: 800, seccion: 3 },
    { id: 7, nombre: "Septimo", nickname: '7', orden: 900, seccion: 3 },
    { id: 8, nombre: "Octavo", nickname: '8', orden: 1000, seccion: 3 },
    { id: 9, nombre: "Noveno", nickname: '9', orden: 1100, seccion: 4 },
    { id: 10, nombre: "Decimo", nickname: '10', orden: 1200, seccion: 4 },
    { id: 11, nombre: "Undecimo", nickname: '11', orden: 1300, seccion: 4 },
    { id: 14, nombre: "Trancisión", nickname: 'T', orden: 200, seccion: 1 },
    // REQUERIMIENTO JULIANA  8 mayo 2023 para registrar interesados de admisiones
    { id: 13, nombre: "Kinder 5", nickname: 'K5', orden: 100, seccion: 1 },
    { id: 117, nombre: "Kinder 4", nickname: 'K4', orden: 97, seccion: 1 },

  ]).pipe(
    map(data => data.sort((a, b) => a.orden - b.orden))
  );

  // cursosAndParents$ = this.cursos$.pipe(
  //   map(data => {
  //     let result = [];
  //     data.forEach(item => {
  //       result = [...result, item, ]
  //     })
  //     return data.map(item => [item, ...item.cursos]);
  //   })
  // );

  constructor(private http: HttpClient) { }

  cursoLabel(id, cursos: Curso[], nickName = true, deep = true): string {
    return this.findCurso(id, cursos, deep)[nickName ? "nickName" : "nombre"];
  }

  findCurso(id, cursos: Curso[], deep = true): Curso {
    let curso: Curso;
    if (deep) {
      cursos.forEach((item) => {
        if (item.id === id) {
          curso = item;
        }
        item.cursos.forEach((subItem) => {
          if (subItem.id === id) {
            curso = subItem;
          }
        });
      });
      return curso;
    }
    curso = cursos.find(
      (obj) =>
        obj.id === id || obj.cursos.findIndex((item) => item.id === id) > -1
    );
    return curso;
  }

  doSearchCursoSeccion(id: number) {
    this.seccionBS.next(id);
  }
  doSearchCursoExcludeSeccion(id: number) {
    this.seccionExcludeBS.next(id);
  }
}
